// @ts-check
import React from 'react';

import { ColorBox } from 'components/sections/ColorBox';
import { ControlHero } from 'components/sections/ControlHero';
import { Faq, Topic } from 'components/sections/Faq';
import { HowToCards } from 'components/sections/HowToCards';
import { Image } from 'components/sections/Image';
import { Layout } from 'components/Layout';
import { Gutter } from 'components/Gutter';
import { Magazine, MagazineArticleCard } from 'components/sections/Magazine';
import { Reviews } from 'components/sections/Reviews';
import { Usp } from 'components/sections/Usp';
import { colorBoxBuy } from 'content/colorBox';
import { controlHeroBuy } from 'content/controlHero';
import { Calculate } from 'components/sections/Calculate';
import { LoanType } from 'enums/LoanType';
import { howToCardsBuy } from 'content/howToCards';
import { reviews } from 'content/reviews';
import { Colors } from 'enums/Colors';
import useMediaQuery from 'utils/useMediaQuery';

import styles from './BuyUsedCar.module.scss';

interface Props {
  articles: MagazineArticleCard[];
  faq: {
    title: string;
    questions: Topic[];
  };
}

export const BuyUsedCar: React.FC<Props> = ({ articles, faq }) => {
  const isMobile = useMediaQuery('(max-width: 768px)');

  return (
    <Layout>
      <div className={styles.wrapper}>
        <ControlHero
          title={controlHeroBuy.title}
          text={controlHeroBuy.text}
          controlTitle={controlHeroBuy.controlTitle}
          controlButtonText={controlHeroBuy.controlButtonText}
          mobileSrc={controlHeroBuy.mobileSrc}
          desktopSrc={controlHeroBuy.desktopSrc}
        />
        <Gutter size="negative">
          <ColorBox
            color={Colors.MintSweet}
            title={colorBoxBuy.title}
            text={colorBoxBuy.text}
            list={colorBoxBuy.list}
            buttons={colorBoxBuy.buttons}
          />
        </Gutter>
        <Gutter size="medium">
          <div className={styles.calculator}>
            <Calculate
              imageSrc="/assets/images/calculator-woman-trustpilot.png"
              loanType={LoanType.NordeaLoan}
            />
          </div>
        </Gutter>

        <Gutter size="medium">
          <HowToCards
            title={howToCardsBuy.title}
            howToItems={howToCardsBuy.howToItems}
            hideImages
            showBg
            showIcons
          />
        </Gutter>

        <Gutter size="medium">
          <Reviews title={reviews.title} reviews={reviews.reviews} />
        </Gutter>
        <Gutter size="xlarge">
          <Usp soldCars={2645} />
        </Gutter>
        <Gutter size="large">
          {isMobile ? (
            <Image
              rounded
              src="/assets/images/my-ride-my-rules-mobile.jpg"
              alt="An electric car and two people in front of a wooden house"
              title="My ride. My rules."
              intro="Att ha en egen bil ska göra dig fri, inte begränsad."
            />
          ) : (
            <Image
              rounded
              src="/assets/images/my-ride-my-rules-desktop.jpg"
              alt="An electric car and two people in front of a wooden house"
              title="My ride. My rules."
              intro="Att ha en egen bil ska göra dig fri, inte begränsad."
            />
          )}
        </Gutter>
        <Gutter size="large">
          <Magazine articles={articles} />
        </Gutter>
        <Gutter size="large">
          <Faq title={faq.title} questions={faq.questions} />
        </Gutter>
      </div>{' '}
    </Layout>
  );
};
